import React, { useState } from "react";
import "./Footer.css";
import Analytics from "./Analytics";
import TermsOfUse from "./TermsOfUse";
import PrivacyContent from "./PrivacyContent";


function Footer({setShowModal, setModalType}) {
  const footerYear = new Date().getFullYear();
  return (
    <>
      <div className="footer_container">
        <p>
          &copy; {footerYear} Accenture. All Rights Reserved. Accenture
          Confidential. For internal use only. Powered by Learning Experiences -
          L&TT, ATCI.

          <button
           className="footer-terms-btn" onClick={() => {
            window.open("https://in.accenture.com/digitalworker/terms-of-use/")
            // setModalType("terms");
            // setShowModal(true);
          }}>Terms of Use</button>

          { " | "}

          <button
           className="footer-privacy-btn" 
           onClick={() => {
            // setModalType("privacy");
            // setShowModal(true);
            window.open("https://in.accenture.com/protectingaccenture/5422-2/")
          }}>Privacy Statement</button>
          <Analytics />
        </p>

        
      </div>
    </>
  );
}

export default Footer;
